
"use client";

import { Link } from "react-router-dom";
import { Moon } from "lucide-react";
import { Logo } from "@/components/logo";
import { UserAvatar } from "@/components/auth/user-avatar";
import { Button } from "@/components/ui/button";
import { SleepToolsDialog } from "@/components/sleep-tools-dialog";
import { cn } from "@/lib/utils";

interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps = {}) {
  return (
    <header className={cn("flex min-h-16 items-center justify-between border-b bg-card px-4 md:px-6 sticky top-0 backdrop-blur-sm z-10 safe-area-top py-2", className)}>
      <Link to="/" className="flex items-center gap-3">
        <Logo className="h-6 w-6 text-primary" />
        <h1 className="text-xl font-bold text-foreground">
          LullabAI
        </h1>
      </Link>
      
      <div className="flex items-center gap-2">
        <SleepToolsDialog>
          <Button 
            variant="outline" 
            size="sm" 
            aria-label="Sleep Tools"
            className="gap-1.5 h-9 rounded-full text-xs font-medium border-primary/20 hover:border-primary/40 bg-background text-foreground shadow-xs"
            title="In-App Sleep Tools: Sound machine & night light"
          >
            <Moon className="h-3.5 w-3.5 text-primary" />
            <span className="hidden sm:inline">Sleep Tools</span>
          </Button>
        </SleepToolsDialog>
        <UserAvatar />
      </div>
    </header>
  );
}
